import AjaxUtils from "../../../util/ajax_utils";

export const deleteVulnerabilities = ({cmp, url, data = {}, success_cb = undefined}) => {
    AjaxUtils.ajax_post({
        url: url,
        data: JSON.stringify(data),
        success: function (data) {
            const count = data.count || 0;
            if (count === 0) {
                cmp.$toast({
                    type: 'error',
                    message: `No vulnerabilities found`,
                })
            } else if (data.count === 1) {
                cmp.$toast({
                    type: 'success',
                    message: 'Vulnerability deleted successfully',
                });
            } else {
                cmp.$toast({
                    type: 'success',
                    message: `${count} vulnerabilities have been deleted successfully`
                })
            }
            if (typeof success_cb === "function" ) {
                success_cb(data);
            }
        }, fail: function () {

        }
    });
};

export const sanitiseFilename = (filename) => {
    //Replace things that Windows explorer can't deal with, even though the underlying NTFS would have no problem actually storing files with these names.
    //Linux (and probably OSX because it's also UNIXy) doesn't like '/' and 0.
    const evilCharacters = " \\/:*?\"<>|";

    return Array.from(filename).map(c => {
        const charCode = c.charCodeAt(0);
        if (charCode >= 32 && charCode < 128 && !evilCharacters.includes(c)) {
            return c;
        } else {
            return "_";
        }
    }).join("");
};
